<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Add Lab",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Add Lab",
            items: [
               {
                  text: "Lab",
                  href: "/labs",
               },
               {
                  text: "Add Lab",
                  active: true,
               },        
            ],


            lab: {
               id: null,
               name : "",
               place: "",
               phone: "",
               email: "",
               password: "",
               country_code: 1,
               pin_no: "",
               clinic_id: null, // only required if type == 2
               token_management_type: 1
            },
            image: "",
            preview_image: "",
            countries: [],
            clinics: [],        // list of clinics for the dropdown
            edit: false,

            lab_location: '',
            lab_marker: { position: { lat: null, lng: null } },
            lab_center: { lat: null, lng: null },
            lab_current_place: null,

            lab_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
            loading: false,
         };
      },
      mounted() {
         this.fetchCountryCodes();
      },

      methods: {
         //sets the position of marker when dragged
         labHandleMarkerDrag(e) {
            this.lab_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         labPanToMarker() {
            this.$refs.labMapRef.panTo(this.lab_marker.position);
            this.$refs.labMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         labHandleMapClick(e) {
            this.lab_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         labSetPlace(place) {
            this.lab_current_place = place;
            if(this.lab_current_place) {
               const marker = {
                  lat: this.lab_current_place.geometry.location.lat(),
                  lng: this.lab_current_place.geometry.location.lng(),
               };
               this.lab_center = marker;
               this.lab_marker.position = marker;
               this.lab_location = place.formatted_address;
            }
         },

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         addLab(){

            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/lab";

            let formData = new FormData();
            formData.append("name", this.lab.name);
            formData.append("country_code", this.lab.country_code); 
            formData.append("mobile", this.lab.phone);
            formData.append("email", this.lab.email);
            formData.append("address", this.lab.place);
            formData.append("password", this.lab.password);
            formData.append("latitude", this.lab_marker.position.lat);
            formData.append("longitude", this.lab_marker.position.lng);
            formData.append("collecting_range", this.lab.collecting_range);
            formData.append("pin_no", this.lab.pin_no); 
            formData.append('image', this.image);
            formData.append("token_management_type", this.lab.token_management_type);

            this.loading = true;

            this.$axios
            .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'labs' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

         },
         
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         }, 
      }
   }
</script>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'labs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addLab()">
                        
                        <div class="row">
                           <b-col md="12" class="form-group">
                              <label class="control-label">Name<span class="text-danger">*</span></label>
                              <b-form-input v-model="lab.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Place<span class="text-danger">*</span></label>
                              <b-form-input v-model="lab.place" v-bind:class="{ 'is-invalid': Boolean(errors.place) }"></b-form-input>
                              <div v-for="(val, index) in errors.place" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Phone<span class="text-danger">*</span></label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="lab.country_code"  v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="lab.phone" maxlength="15" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                  <div v-for="(val, index) in errors.country_code" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                               </b-input-group>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Email<span class="text-danger">*</span></label>
                              <b-form-input v-model="lab.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                              
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                              <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                            <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Token Management Type <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model="lab.token_management_type"
                                 name="labTokenType"
                                 :class="{ 'is-invalid': Boolean(errors.token_management_type) }"
                                 inline
                                 >
                                 <div class="form-check-inline">
                                 <b-form-radio :value="1">Schedule-based token management system</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                 <b-form-radio :value="2">Current token tracking</b-form-radio>
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <label class="control-label">Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="lab.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <div class="form-group col-md-6">
                                 <label>Pin Number <span class="text-danger">*</span></label>
                                 <b-form-input v-model="lab.pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                                 <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="labSetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="lab_location"/>
                              
                              <GmapMap v-if="lab_location"
                                 :center="lab_center"
                                 :zoom="18"
                                 map-style-id="lab-roadmap"
                                 :options="lab_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="labMapRef"
                                 @click="labHandleMapClick">
                                    <GmapMarker
                                       :position="lab_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="labHandleMarkerDrag"
                                       @click="labPanToMarker"
                                    />
                              </GmapMap>                          
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="lab_marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="lab_marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="6" xl="6" class="form-group"  v-if ="lab.token_management_type == 1">
                              <label class="control-label">Collecting Range In Km <span class="text-danger">*</span></label>
                              <b-form-input v-model="lab.collecting_range" v-bind:class="{ 'is-invalid': Boolean(errors.collecting_range) }"></b-form-input>
                              <div v-for="(val, index) in errors.collecting_range" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div class="page-loader" v-if="!loading">
                                 <button class="btn btn-primary me-2" type="submit">Save</button>
                                 <router-link :to="{ name: 'labs' }" class="btn btn-light">Cancel</router-link>
                              </div>
                              <div class="page-loader" v-else>
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
